@use "../../../../../styles/Constants.scss" as Constants;
@use "../../../../../styles/Colors.scss" as Colors;

.container {
	padding: Constants.$val-spacing-m;
	margin-top: Constants.$val-spacing-s;

	.titleAndOptions {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: Constants.$val-spacing-m;

		.title {
			display: flex;
			flex: 1;
			font-size: Constants.$val-fontSizeSmall;
			color: Colors.$col-design-grey10;
			text-transform: uppercase;

			[class*="materialRateSource"] {
				margin-right: Constants.$val-spacing-xs;
			}
		}

		.options {
			display: flex;
			align-items: center;
			justify-content: flex-end;
		}

		.titleText {
			display: inline-block;
			line-height: Constants.$val-spacing-m;
			vertical-align: middle;
			margin-left: Constants.$val-spacing-s;
		}
	}

	.expander {
		margin-top: Constants.$val-spacing-m;
	}
}
